module.exports = __webpack_public_path__ + "static/media/DrumMachine.bcc8f1f3.gif";